export const aboutData = {
    title: "About Me",
    description1: "My name is subhashni jha. I'm a full stack software developer based in Gurgaon.",
    description2: "I am a passionate programmer with a strong foundation in full-stack development. A quick learner dedicated to continuous improvement. I thrive in dynamic environments and love exploring new technologies. My current stack includes JavaScript, React, Node.js, Express, MongoDB,Python,MySql, and more.",
}